import { styled } from 'styled-components'

export const RemoveProductWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const RemoveProductImage = styled.div`
  width: 220px;
  height: 220px;
  margin-right: 48px;
`
export const RemoveProductContent = styled.div`
  color: ${props => props.theme.color.black};
  flex: 1;
`
export const RemoveProductMessage = styled.div`
  font-size: 20px;
  color: ${props => props.theme.color.black};
  margin-bottom: 0.75rem;
`
export const RemoveProductName = styled.div`
  font-family: ${props => props.theme.font.secondary};
  font-size: 42px;
  color: ${props => props.theme.color.black};
`
export const RemoveProductCaption = styled.div`
  font-size: 18px;
  color: ${props => props.theme.color.black};
  opacity: 0.5;
`
export const RemoveProductActions = styled.div`
  display: flex;
  margin-top: 16px;
  flex-direction: row;
`
